import React from "react";
import Topsection from "./Topsection";
import MiddleSetion from "./MiddleSetion";
import LastSec from "./LastSec";
import SEO from "../SEO";
import { useEffect } from "react";
import ReactGA from "react-ga4";

const GetInvolved = () => {
	useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: "/get-involved",
      title: "Get Involved with SynergyCare Foundation",
    });
  });
	return (
		<div className='max-[1440px] w-[90%] mx-auto py-16 relative'>
			<SEO
				title='Get Involved with SynergyCare Foundation'
				description='Volunteer, donate, or partner with SynergyCare Foundation to make healthcare accessible for all.'
				name='SynergyCare Foundation'
				type=''
			/>
			<Topsection />
			<MiddleSetion />
			<LastSec />
		</div>
	);
};

export default GetInvolved;
